import dayjs from "dayjs";

const DAY_FORMAT = "YYYY-MM-DD";

export function toDayValue(date?: string): string | undefined {
  return date ? dayjs(date).format(DAY_FORMAT) : undefined;
}

export function mapValidityToPayload(values: {
  validFrom?: string;
  validTo?: string;
}): { validFrom?: string; validTo?: string } {
  return {
    validFrom: values.validFrom
      ? dayjs(values.validFrom).startOf("day").toISOString()
      : undefined,
    validTo: values.validTo
      ? dayjs(values.validTo).endOf("day").toISOString()
      : undefined,
  };
}
